import classNames from "classnames";
import { forwardRef, HTMLAttributes } from "react";

import { DefaultLabel, LargeLabel } from "./Label.styled";

export type LabelProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Set label color
   *
   * @type {"orange" | "blue" | "green" | "grey" | "red" | "yellow" | "dark-yellow"}
   * @default {"orange"}
   */
  color?: "orange" | "blue" | "green" | "grey" | "red" | "yellow" | "dark-yellow";

  /**
   * Set label size
   *
   * @type {"default" | "large"}
   * @default {"default"}
   */
  size?: "default" | "large";

  /**
   * Set label shimmering or not
   * @default {false}
   */
  shimmer?: boolean;
};

const defaultProps: LabelProps = {
  color: "orange",
  size: "default",
  shimmer: false
};

const LabelComponent = {
  default: DefaultLabel,
  large: LargeLabel
};

const Label = forwardRef<HTMLDivElement, LabelProps>((props, ref) => {
  const { children, className, color, size, shimmer, ...restProps } = props;
  const dotClass = classNames("c-label", className);

  const Comp = LabelComponent[size];

  return (
    <Comp data-testid="qa-label" ref={ref} className={dotClass} color={color} {...restProps} shimmer={shimmer}>
      {children}
    </Comp>
  );
});

Label.defaultProps = defaultProps;

export default Label;
